<template>
	<v-container grid-list-xl pb-0>
		<ProjectForm
			:edit-project="editProject"
			:existing-projects="existingProjects"
			@update-project="updateProject"
		>
			<v-btn
				v-if="closable"
				slot="buttons"
				flat
				color="error"
				@click="$emit('cancel')"
			>
				Close
			</v-btn>
		</ProjectForm>
		<v-divider class="mt-2" />
		<ImageUpload :item="editProject" :loadable="false" @upload="$emit('saving-done')" />
	</v-container>
</template>

<script>
import ProjectForm from '@/components/Project/ProjectForm';
import ImageUpload from '@/components/ImageUpload';

export default {
	components: {
		ProjectForm,
		ImageUpload,
	},
	props: {
		editProject: { type: Object, default: null },
		existingProjects: { type: Array, default: () => [] },
		closable: { type: Boolean, default: true },
	},
	methods: {
		updateProject(project, oldName) {
			project.save().then((resp) => {
				this.$notify('success', `Project "${project.name}" has been renamed.`);
			}).catch(({ response }) => {
				dump('Error updating project from settings', response);
				if (response.response.status === 422) {
					this.$notify('error', `Name "${project.name}" has already been taken.`);
					return;
				}
				if (response.response.status === 403) {
					this.$notify('error', 'You do not have permission to update this project.');
					return;
				}
				this.$notify('error', `Failed to rename project "${oldName}".`);
			}).finally(() => {
				// project.reset(); // Not sure why we need this, causes and error "Collection is not valid"
				this.$emit('saving-done');
			});
		},
	},
};
</script>
